import { Stack } from "@mui/material";
import { useContext } from "react";

import Context from "../../../../../context";
import RadioItem from "./RadioItem";
import useUpdateRadioRow from "./useUpdateRadioRow";

// ----------------------------------------------------------------------

type Props = {
	id: string;
};

export const RadioRow = ({ id }: Props) => {
	const { state } = useContext(Context);

	const isSelected = !!state.selectedPositions.find((i) => i.id === id);
	const shares = state.selectedPositions.find((i) => i.id === id)?.shares;
	const isTotal = isSelected && !shares && shares !== null;

	const { onSelectParcial, onSelectTotal } = useUpdateRadioRow({ id });

	return (
		<Stack direction={"row"} alignItems={"center"} gap={0.5}>
			<RadioItem
				isChecked={!!shares || shares === null}
				onClick={onSelectParcial}
				title={"Parcial"}
			/>
			<RadioItem isChecked={isTotal} onClick={onSelectTotal} title={"Total"} />
		</Stack>
	);
};

export default RadioRow;
